
import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Category } from '../types/types'
import CollectionCard from './CollectionCard';
import ProductCard from './ProductCard';

// ========================
// Imports des images pour les pantalons
// ========================
import p1_img1 from '../assets/images/PremiumInterlock/p1_1.jpg';
import p1_img2 from '../assets/images/PremiumInterlock/p1_2.jpg';
import p1_img3 from '../assets/images/PremiumInterlock/p1_3.jpg';
import p1_img4 from '../assets/images/PremiumInterlock/p1_4.jpg';

import p2_img1 from '../assets/images/Jogging/p2_1.jpg';
import p2_img2 from '../assets/images/Jogging/p2_2.jpg';
import p2_img3 from '../assets/images/Jogging/p2_3.jpg';
import p2_img4 from '../assets/images/Jogging/p2_4.jpg';

import p3_img1 from '../assets/images/Cargo/p3_1.jpg';
import p3_img2 from '../assets/images/Cargo/p3_2.jpg';
import p3_img3 from '../assets/images/Cargo/p3_3.jpg';
import p3_img4 from '../assets/images/Cargo/p3_4.jpg';

// ========================
// Imports des images pour les ensembles
// ========================
// Ensemble Urbain
import e1_img1 from '../assets/images/EnsembleUrbain/1.jpg';
import e1_img2 from '../assets/images/EnsembleUrbain/2.jpg';
import e1_img3 from '../assets/images/EnsembleUrbain/3.jpg';
import e1_img4 from '../assets/images/EnsembleUrbain/4.jpg';

// Ensemble Classique
import e2_img1 from '../assets/images/EnsembleClassique/e2_1.jpg';
import e2_img2 from '../assets/images/EnsembleClassique/e2_2.jpg';
import e2_img3 from '../assets/images/EnsembleClassique/e2_3.jpg';
import e2_img4 from '../assets/images/EnsembleClassique/e2_4.jpg';

// Ensemble Sportswear
import e3_img1 from '../assets/images/EnsembleSportswear/e3_1.jpg';
import e3_img2 from '../assets/images/EnsembleSportswear/e3_2.jpg';
import e3_img3 from '../assets/images/EnsembleSportswear/e3_3.jpg';
import e3_img4 from '../assets/images/EnsembleSportswear/e3_4.jpg';

// pull zippeée
import e4_img1 from '../assets/images/EnsembleZIPe/c.jpg';
import e4_img2 from '../assets/images/EnsembleZIPe/c2.jpg';
import e4_img3 from '../assets/images/EnsembleZIPe/c3.jpg';

// Ensemble (nouveau)
import e40img1 from '../assets/images/Ensemblenew/01.jpg';
import e40img2 from '../assets/images/Ensemblenew/02.jpg';
import e40img3 from '../assets/images/Ensemblenew/03.jpg';
import e40img4 from '../assets/images/Ensemblenew/04.jpg';
import e40img5 from '../assets/images/Ensemblenew/05.jpg';  
import e40img6 from '../assets/images/Ensemblenew/06.jpg';

//surchemise
import surchemise1 from '../assets/images/Surchemise/1.jpg';
import surchemise2 from '../assets/images/Surchemise/2.jpg';
import surchemise3 from '../assets/images/Surchemise/3.jpg';
import surchemise4 from '../assets/images/Surchemise/4.jpg';


//pull col rond
import pullcolrond1 from '../assets/images/PullColRond/1.jpg';
import pullcolrond2 from '../assets/images/PullColRond/2.jpg';
import pullcolrond3 from '../assets/images/PullColRond/3.jpg';
import pullcolrond4 from '../assets/images/PullColRond/4.jpg';
import pullcolrond5 from '../assets/images/PullColRond/5.jpg';

//pontalons
import p1 from '../assets/images/Pantalons/p1.jpg';
import p2 from '../assets/images/Pantalons/p2.jpg';
import p3 from '../assets/images/Pantalons/p3.jpg';
import p4 from '../assets/images/Pantalons/p4.jpg';
import p5 from '../assets/images/Pantalons/p5.jpg';
import p6 from '../assets/images/Pantalons/p6.jpg';

//surchemises
import surchemise5 from '../assets/images/Surchemise2/1.jpg';
import surchemise6 from '../assets/images/Surchemise2/2.jpg';
import surchemise7 from '../assets/images/Surchemise2/3.jpg';

// Lookbook (inchangé)
import lookbook1 from '../assets/images/Gemini_Generated_Image_zakhw3zakhw3zakh (1).png';
import lookbook2 from '../assets/images/Gemini_Generated_Image_5ol3bq5ol3bq5ol3.png';
import lookbook3 from '../assets/images/Gemini_Generated_Image_hpg7gwhpg7gwhpg7.png';
import lookbook4 from '../assets/images/Gemini_Generated_Image_9duq6a9duq6a9duq.png';




const Collections: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<Category | 'all'>('all');
  const [imagesLoaded, setImagesLoaded] = useState<{ [key: string]: boolean }>({});

  const { ref: headerRef, inView: headerInView } = useInView({ threshold: 0.12, triggerOnce: true });
  const { ref: gridRef, inView: gridInView } = useInView({ threshold: 0.12, triggerOnce: true });
  const { ref: stripRef, inView: stripInView } = useInView({ threshold: 0.12, triggerOnce: true });

  // Produits
  const products = [
    // Pantalons
    {
      id: '8',
      name: 'Pantalon Premium Interlock',
      category: 'essential' as Category,
      description: 'GERAK — Pantalon Premium. Interlock double face, coton lycra, 4 couleurs.',
      ref: 'GRK-008',
      tag: 'Premium',
      badge: 'Nouveauté',
      featured: false,
      images: [p1_img1, p1_img2, p1_img3, p1_img4],
    },
    {
      id: '9',
      name: 'JOG Baggy B',
      category: 'urban' as Category,
      description: 'Jogging coupe relax, tissu ultra-doux, passepoil structurant. Confort maximal, style minimaliste.',
      ref: 'GRK-009',
      tag: 'Molletonné',
      images: [p2_img1, p2_img2, p2_img3, p2_img4],
    },
    {
      id: '10',
      name: 'Pantalon Cargo Élastique',
      category: 'classique' as Category,
      description: 'Élégance simple. Coupe cargo sans poches, finition élastique. Teintes neutres.',
      ref: 'GRK-010',
      tag: 'Cargo',
      images: [p3_img1, p3_img2, p3_img3, p3_img4],
    },
    // Ensembles
    {
      id: '11',
      name: 'Ensemble Urbain',
      category: 'urban' as Category,
      description: 'Veste oversize + pantalon assorti. Tissu technique, détails réfléchissants. 3 coloris.',
      ref: 'GRK-011',
      tag: 'Urbain',
      // badge: 'Nouveauté',
      // featured: true,
      images: [e1_img1, e1_img2, e1_img3, e1_img4],
    },
    {
      id: '12',
      name: 'Ensemble Classique',
      category: 'classique' as Category,
      description: 'Blazer ajusté + pantalon droit en laine peignée. Élégance intemporelle.',
      ref: 'GRK-012',
      tag: 'Formal',
      images: [e2_img1, e2_img2, e2_img3, e2_img4],
    },
    {
      id: '13',
      name: 'Ensemble Sportswear',
      category: 'essential' as Category,
      description: 'Sweat molletonné + jogging taille élastique. Confort quotidien, finitions soignées.',
      ref: 'GRK-013',
      tag: 'Casual',
      badge: 'Best-seller',
      images: [e3_img1, e3_img2, e3_img3, e3_img4],
    },
    {
      id: '14',
      name: 'Ensemble Premium',
      category: 'essential' as Category,
      description: 'Tissu interlock double face, Coton Lycra, confort supérieur.',
      ref: 'GRK-014',
      tag: 'Zippé',
      // badge: 'Nouveauté',
      featured: false,
      images: [ e40img1, e40img2, e40img3, e40img4, e40img5, e40img6],
    },
    {
      id: '15',
      name: 'Pull zippé',
      category: 'urban' as Category,
      description: 'Pull zippée,Tissu respirant, coupe moderne. 2 coloris.',
      ref: 'GRK-014',
      tag: 'Zippé',
      // badge: 'Nouveauté',
      featured: false,
      images: [ e4_img2, e4_img3],
    },
     {
      id: '16',
      name: 'Surchemise iconique ',
      category: 'classique' as Category,
      description: ' surchemise iconique, le neutre parfait pour un look urbain et sobre. 4 coloris.',
      ref: 'GRK-0142',
      tag: 'Surchemise',
       badge: 'Nouveauté',
      featured: false,
      images: [surchemise4, surchemise1, surchemise2, surchemise3],
    },
       {
      id: '17',
      name: 'Pull Col Rond',
      category: 'essential' as Category,
      description: ' Pull Col Rond Coton Lycra, Interlock double face premium',
      ref: 'GRK-0142s',
      tag: 'Pull' ,
       badge: 'Nouveauté',
      featured: false,
      images: [pullcolrond1, pullcolrond2, pullcolrond3, pullcolrond4, pullcolrond5],
    },
    {
      id: '18',
      name: ' Silhouette moderne',
      category: 'urban' as Category,
      description: '  Silhouette moderne,L’équilibre parfait entre confort et élégance',
      ref: 'GRK-01d42s',
      tag: 'Pull' ,
       badge: 'Nouveauté',
      featured: false,
      images: [p1, p2, p3, p4, p5, p6],
    },
      {
      id: '19',
      name: ' Surchemises MS Collection',
      category: 'classique' as Category,
      description: '  surchemises tendance, parfaites pour un look moderne',
      ref: 'GRK-s01d42ss',
      tag: 'Surchemises' ,
      badge: 'focus',
      featured: false,
      images: [surchemise5, surchemise6, surchemise7],
    },
  ];

  const lookbookImages = [lookbook1, lookbook2, lookbook3, lookbook4];
  const filteredProducts = activeFilter === 'all' ? products : products.filter(p => p.category === activeFilter);

  const handleImageLoad = (id: string) => {
    setImagesLoaded(prev => ({ ...prev, [id]: true }));
  };

  return (
    <section id="collections" className="pt-40 pb-32 px-10 max-w-[1260px] mx-auto">
      <div className="section-header">
        <span className="section-tag">— Collections —</span>
        <h2 className="section-title">Un Style Pour Chaque Occasion</h2>
        <p className="section-desc">
          GERAK propose une gamme complète de vêtements masculins.
        </p>
      </div>

      {/* Grille des produits */}
      <div className={`reveal ${gridInView ? 'visible' : ''}`} ref={gridRef}>
        <div className="flex flex-wrap items-end justify-between gap-5 mb-10">
          <div>
            <h3 className="font-serif text-[clamp(26px,3.5vw,44px)] font-semibold text-white tracking-[0.04em]">
              Nos Pièces
            </h3>
            <p className="text-[#9a9a9a] text-xs mt-1.5 tracking-wider">
              Découvrez notre collection en images réelles
            </p>
          </div>
          <div className="flex gap-3 flex-wrap">
            {(['all', 'essential', 'urban', 'classique'] as const).map(filter => (
              <button
                key={filter}
                className={`border ${
                  activeFilter === filter
                    ? 'bg-white text-black border-white'
                    : 'border-[#333333] text-[#9a9a9a] hover:bg-white hover:text-black hover:border-white'
                } text-[9px] tracking-[2.5px] uppercase px-4 py-2 transition-all`}
                onClick={() => setActiveFilter(filter)}
              >
                {filter === 'all' ? 'Tout' : filter.charAt(0).toUpperCase() + filter.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {filteredProducts.map(product => (
            <ProductCard
              key={product.id}
              {...product}
              onLoad={() => handleImageLoad(product.id)}
            />
          ))}
        </div>

        {/* Lookbook strip */}
        <div
          className={`mt-20 bg-[#1a1a1a] border border-[#333333] p-12 md:p-14 flex flex-col md:flex-row items-center justify-between gap-10 reveal ${stripInView ? 'visible' : ''}`}
          ref={stripRef}
        >
          <div>
            <h3 className="font-serif text-[clamp(24px,3vw,38px)] font-semibold text-white mb-2.5">
              Lookbook GERAK
            </h3>
            <p className="text-[#9a9a9a] text-sm leading-relaxed max-w-[400px]">
              Découvrez comment porter nos pièces avec nos looks complets.
            </p>
          </div>
          <div className="flex gap-3 flex-wrap">
            {lookbookImages.map((image, index) => (
              <div
                key={index}
                className="w-[90px] h-[120px] bg-[#222222] border border-dashed border-[#333333] overflow-hidden group cursor-pointer relative"
              >
                <img 
                  src={image} 
                  alt={`Look 0${index + 1}`}
                  className="w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  onLoad={(e) => {
                    e.currentTarget.style.opacity = '1';
                  }}
                  onError={(e) => {
                    console.error(`Erreur lookbook ${index + 1}`);
                    e.currentTarget.style.display = 'none';
                  }}
                />
                <span className="absolute inset-0 flex items-center justify-center text-[7px] tracking-[2px] text-[#333333] uppercase group-hover:opacity-0 transition-opacity duration-300">
                  Look 0{index + 1}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Collections;